import { Pipe, PipeTransform } from '@angular/core';
import { TimeagoPipe } from 'ngx-timeago';

@Pipe({
  name: 'timeAgo',
  pure: false
})
export class TimeAgoExtendsPipe extends TimeagoPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value !== undefined && value !== null) {
      return super.transform(value);
    }
    return null;
  }
}
